import React, { useState, useEffect, useRef } from 'react';
import { Redirect, Link } from 'react-router-dom';

import { 
    reqGET,
    set_language,
	content_language,  
} from '../../../Utils';
import { api_crud_base, api_list_route, data_interface, endpoints } from './Config';
import "../../../assets/dataTable.css";

import { getTokenInfo } from '../../../UseToken';

import { language } from '../../WEBContent/Language';

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);
    //console.log('REVIEWERS', dados.info.reviewers[0].name)

    const [isloading, setLoading] = useState(true);
    const [isRedirect, /*setRedirect*/] = useState(false);

    const articles = useRef([]);
    const reviewers = useRef([]);

    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

    const [profile, /*set_profile*/] = useState(getTokenInfo().profile);

    //const [refresh, setRefresh] = useState(0);

    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id_serch) => {

        let list_route = api_list_route(getTokenInfo().companycode)
        //console.log(list_route)
        //return await reqGET(`${api_crud_route}/${id_serch}`)
        return await reqGET(`${list_route}/${id_serch}`)
            .then(res => set_dados(res.data[0]))
            .catch(() => 404
                //  TODO: ENVIAR PÁGINA 404
                //  alert(error)); 
            );
    }

    useEffect(() => {
        //if (props.location.state !== undefined) {

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        fetchInfo(props.location.state.item['id']).then(async () => {

            let lista_revs = await get_reviewers()
            //console.log('lista_revs->', lista_revs)
            reviewers.current = lista_revs

            let lista_arts = await get_articles(props.location.state.item['id'])
            //console.log('lista_arts->', lista_arts)
            articles.current = lista_arts
            //setRefresh(refresh + 1)

            //console.log('++++++++++', articles.current)

            setLoading(false)
        })
    }, [props]);

    const get_reviewers = async () => {
        let aReviewers = [];

        return await reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Revisor`)
            .then(res => {
                //console.log(res.data)

                res.data.forEach(v => {
                    aReviewers.push({ label: v.name, label2: v.surname, value: v.id })
                });

                //set_reviewers(aReviewers)
                return aReviewers
                //console.log('REVIEWERS', aReviewers)
            })
            .catch(erro => { console.log(erro); alert('Erro'); })
    }

    const get_articles = async (id) => {

        let aArticles = [];

        /* CHAMADA ARTIGOS */
        return await reqGET(`${api_crud_base}/submissions/${getTokenInfo().companycode}/list`)
            .then(res => {
                //console.log(res.data)
                res.data.forEach(x => {
                    let aux = { id: x.id, title: x.info.title, cfp: x.info.id_cfp, reviewers: reviewers }

                    if(x.info.id_cfp === id){
                        aArticles.push(aux);
                    }
                });
                return aArticles
            })

            .catch(erro => { console.log(erro); alert('Erro'); })
    }

    /*const handleSingleCheck = e => {

        //console.log(e.target)
        const { name, value } = e.target;
        console.log(name)
        console.log(value)

        //set_dados(aux.reviewers[name] = value)
        //console.log('Dados Current:' + JSON.stringify(dados))

    }*/

    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">LOADING</h2>
                    <p>LOADING</p>
                    <div className="overlay">
                        <div className="overlay__inner">
                            <div className="overlay__content"><span className="spinner"></span></div>
                        </div>
                    </div>
                </div>
            </main>
            :
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">{language[lang].events}</h2>
                    <p>{language[lang].home} / {language[lang].events} / {dados.info.name}</p>
                </div>

                <div className={`dash-cards-2 body`}>
                    <div className="card">
                        <div className="card-body">
                            <h2 className="dash-title">{dados.info.name}</h2>
                            <div className="div-break" />
                            <div className="div-group">
                                <span className="flex-1">
                                    <h4>{language[lang].type}</h4>
                                    <p>{dados.info.tipo}</p>
                                </span>
                            </div>

                            <div className="div-break"></div>
                            <div className="div-group">
                                <span className="flex-1">
                                    <h4>{ language[ lang ].description }</h4>
                                    <p>{dados.info.description}</p>
                                </span>
                            </div>

                            <div className="div-break"></div>
                            <h2 className={dados.info.cfp.length > 0 ? "dash-title assec-mt-30" : "d-none"}>Call for Papers</h2>
                            {
                            dados.info.cfp.map((elem, index) => {
                                if(elem.name === '')
                                    return ''
                                else {
                                    let aux_data_inicio = elem.data_inicio.filter((v) => v.estado = 'activo').pop()
                                    let aux_data_submissao = elem.data_submissao.filter((v) => v.estado = 'activo').pop()
                                    let aux_data_limite_fim = elem.data_limite_fim.filter((v) => v.estado = 'activo').pop()
                                    
                                    return(
                                        <span key={index}>
                                            <div className="div-group assec-mt-15">
                                                <span className="flex-1">
                                                    <h3 className="titulo-primario">{ language[ lang ].name }</h3>
                                                    <p className="dash-p-title">{elem.name}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].description }</h4>
                                                    <p>{elem.descricao}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].add_new_cfp_start_date }</h4>
                                                    <p>{aux_data_inicio.data}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].add_new_cfp_submission_date }</h4>
                                                    <p>{aux_data_submissao.data}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].add_new_cfp_end_date }</h4>
                                                    <p>{aux_data_limite_fim.data}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].add_new_cfp_sup_mat_deliv_date }</h4>
                                                    <p>{elem.data_marerial_suplementar}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].add_new_cfp_rev_resp_date }</h4>
                                                    <p>{elem.data_resposta_revisao}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].add_new_cfp_article_edit_deadline }</h4>
                                                    <p>{elem.data_limite_edicao}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].add_new_cfp_rev_fin_dec_date }</h4>
                                                    <p>{elem.data_decisao_final_revisor}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].add_new_cfp_process_end_date }</h4>
                                                    <p>{elem.data_final_processo}</p>
                                                </span>
                                                <span className="flex-1">
                                                </span>
                                            </div>
                                        </span>
                                    )
                                }
                            })
                            }

                            {/* <div className="div-break"></div>
                            <h2 className={dados.info.topicos.length > 0 ? "dash-title assec-mt-30" : "d-none"}>Tópicos</h2>
                            {
                            dados.info.topicos.map((elem, index) => {
                                if(elem.nome === '')
                                    return ''
                                else {
                                    return(
                                        <div key={index} className="div-group">
                                            <span className="flex-1">
                                                <p>{elem.nome}</p>
                                            </span>
                                        </div>
                                    )
                                }
                            })
                            } */}

                           {/*  <div className="div-break"></div>

                            <h2 className={dados.info.cfp.length > 0 ? "dash-title" : "d-none"}>Call for Papers</h2>
                            {
                            dados.info.cfp.map((elem, index) => {
                                if(elem.name === '')
                                    return ''
                                else {
                                    let aux_data_inicio = elem.data_inicio.filter((v) => v.estado = 'activo')
                                    let aux_data_submissao = elem.data_submissao.filter((v) => v.estado = 'activo')
                                    let aux_data_limite_fim = elem.data_limite_fim.filter((v) => v.estado = 'activo')
                                    
                                    return(
                                        <span key={index}>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>Nome do Call for Papers</h4>
                                                    <p>{elem.name}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>Descrição do Call for Papers</h4>
                                                    <p>{elem.descricao}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>Data de início</h4>
                                                    <p>{aux_data_inicio[0].data}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>Data de Submissão</h4>
                                                    <p>{aux_data_submissao[0].data}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>Data de Fim</h4>
                                                    <p>{aux_data_limite_fim[0].data}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>Data de entrega de material suplementar</h4>
                                                    <p>{elem.data_marerial_suplementar}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>Data de resposta de revisão</h4>
                                                    <p>{elem.data_resposta_revisao}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>Data limite de edição de artigo</h4>
                                                    <p>{elem.data_limite_edicao}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>Data de decisão final do revisor</h4>
                                                    <p>{elem.data_decisao_final_revisor}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>Data de final do processo</h4>
                                                    <p>{elem.data_final_processo}</p>
                                                </span>
                                                <span className="flex-1">
                                                </span>
                                            </div>
                                        </span>
                                    )
                                }
                            })
                            }

                            <div className="div-break"></div>
                            <h2 className={dados.info.topicos.length > 0 ? "dash-title" : "d-none"}>Tópicos</h2>
                            {
                            dados.info.topicos.map((elem, index) => {
                                if(elem.nome === '')
                                    return ''
                                else {
                                    return(
                                        <div key={index} className="div-group">
                                            <span className="flex-1">
                                                <p>{elem.nome}</p>
                                            </span>
                                        </div>
                                    )
                                }
                            })
                            } */}

                            <div className="div-break"></div>
                            <h2 className={dados.info.convidados.length > 0 ? "dash-title assec-mt-30" : "d-none"}>{ language[ lang ].guests }</h2>
                            {
                            dados.info.convidados.map((elem, index) => {
                                if(elem.nome === '')
                                    return ''
                                else {
                                    return(
                                        <span key={index}>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>{language[lang].name}</h4>
                                                    <p>{elem.nome}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].guest_area }</h4>
                                                    <p>{elem.area}</p>
                                                </span>
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].guest_affiliation }</h4>
                                                    <p>{elem.instituicao}</p>
                                                </span>
                                            </div>
                                            <div className="div-group">
                                                <span className="flex-1">
                                                    <h4>{ language[ lang ].guest_description }</h4>
                                                    <p>{elem.descricao}</p>
                                                </span>
                                            </div>
                                        </span>
                                    )
                                }
                            })
                            }

                            <div className="div-break"></div>
                            <h2 className={dados.info.editores.length > 0 ? "dash-title assec-mt-30" : "d-none"}>{language[lang].publishers}</h2>
                            {
                            dados.info.editores.map((elem, index) => {
                                if(elem.name === '')
                                    return ''
                                else {
                                    return(
                                        <div key={index} className="div-group">
                                            <span className="flex-1">
                                                <p>{elem.name}</p>
                                            </span>
                                        </div>
                                    )
                                }
                            })
                            }

                            <div className="div-break"></div>
                            <h2 className="dash-title assec-mt-30">{language[lang].reviewers}</h2>
                            <div className="div-group">
                                <span className="flex-1">
                                    <h4>{ language[ lang ].max_numb_art_reviewer }</h4>
                                    <p>{dados.info.reviewers.max_articles}</p>
                                </span>
                                {/* <span className="flex-1">
                                    <h4>Pode submeter artigo?</h4>
                                    <p>{dados.info.reviewers.submit}</p>
                                </span> */}
                                <span className="flex-1">
                                    <h4>{ language[ lang ].reviewer_attrib_method }</h4>
                                    <p>{dados.info.reviewers.atribuition_type}</p>
                                </span>
                            </div>
                            <div className="div-group">
                                <span className="flex-2">
                                    <h4>{ language[ lang ].author_question_authorization}</h4>
                                    <p>{dados.info.reviewers.questions_visible_to_authors === 'true' ? language[ lang ].yes : language[ lang ].no}</p>
                                </span>
                                {/* <span className="flex-2">
                                    <h4>Pode submeter artigo?</h4>
                                    <p>{dados.info.reviewers.submit}</p>
                                </span> */}
                            </div>
                            {profile !== 'Autor' ?
                                <div>
                                    <h4>{ language[ lang ].questions }</h4>
                                    {
                                    dados.info.reviewers.questions.map((elem, index) => {
                                        if(elem.name === '')
                                            return ''
                                        else {
                                            return(
                                                <div key={index} className="div-group">
                                                    <span className="flex-1">
                                                        <p>{elem.pergunta}</p>
                                                    </span>
                                                </div>
                                            )
                                        }
                                    })
                                    }
                                </div>
                            : null }
                            {
                            dados.info.reviewers.list.map((elem, index) => {
                                if(elem.name === '')
                                    return ''
                                else {
                                    return(
                                        <div key={index} className="div-group">
                                            <span className="flex-1">
                                                <p>{elem.name}</p>
                                            </span>
                                        </div>
                                    )
                                }
                            })
                            }

                            <div className="div-break"></div>
                            <h2 className="dash-title assec-mt-30">{language[lang].authors}</h2>
                            <div className="div-group">
                                <span className="flex-1">
                                    <h4>{ language[ lang ].max_numb_art_author }</h4>
                                    <p>{dados.info.authores.max_articles}</p>
                                </span>
                                <span className="flex-2">
                                </span>
                            </div>
                            {
                            dados.info.authores.list.map((elem, index) => {
                                if(elem.name === '')
                                    return ''
                                else {
                                    return(
                                        <div key={index} className="div-group">
                                            <span className="flex-1">
                                                <p>{elem.name}</p>
                                            </span>
                                        </div>
                                    )
                                }
                            })
                            }

                            <div className="div-break"></div>
                            <h2 className="dash-title assec-mt-30">{language[lang].articles}</h2>
                            <div className="div-group">
                                <span className="flex-1">
                                    <h4>{ language[ lang ].max_numb_rev_per_art }</h4>
                                    <p>{dados.info.articles.max_reviewers_article}</p>
                                </span>
                                <span className="flex-1">
                                    <h4>{ language[ lang ].review_type }</h4>
                                    <p>{dados.info.articles.review_type}</p>
                                </span>
                                <span className="flex-1">
                                </span>
                            </div>
                            <div className="div-group">
                                <span className="flex-1">
                                    <h4>{ language[ lang ].file_types }</h4>
                                    <p>{dados.info.articles.file_type.join('; ')}</p>
                                </span>
                                <span className="flex-1">
                                    <h4>{ language[ lang ].accepted_languages}</h4>
                                    <p>{dados.info.articles.linguas.join(', ')}</p>
                                </span>
                                <span className={dados.info.articles.template.length > 0 ? "flex-1" : "d-none"} >
                                    <h4>{ language[ lang ].template }</h4>
                                    {
                                    dados.info.articles.template.map((v, key) => {
                                        //console.log(value)
                                        return (
                                            <div key={key}>
                                                <p><a href={v.path + v.source_name} download={v.name} target="_blank" rel="noreferrer">{v.name}</a></p>
                                            </div>
                                        )
                                    })
                                    }
                                </span>
                            </div>
                            
                            {
                            dados.info.articles.list.map((elem, index) => {
                                if(elem.title === '')
                                    return ''
                                else {
                                    return(
                                        <div key={index} className="div-group">
                                            <span className="flex-1">
                                                <p>{elem.title}</p>
                                            </span>
                                        </div>
                                    )
                                }
                            })
                            }
                        </div>

                    </div>
                </div>

                <div className={'dash-cards-2 footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">
                                <li className="nav-item">
                                    <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                        <img alt='' src={'./img/seta_2.svg'} />
                                        <span>{ language[ lang ].back }</span>
                                    </Link>
                                </li>

                            </ul>
                        </div>
                    </nav>
                </div>
            </main >
}